import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { userAPI } from '../utils/api';
import { toast } from 'react-toastify';

const CompanyModal = ({ show, onComplete, loading = false }) => {
  const [company, setCompany] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!company || company.trim() === '') {
      setError('Veuillez saisir le nom de votre entreprise');
      return;
    }

    if (company.trim().length < 2) {
      setError('Le nom de l\'entreprise doit contenir au moins 2 caractères');
      return;
    }

    setSubmitting(true);
    setError('');

    try {
      const response = await userAPI.updateProfile({ company: company.trim() });
      toast.success('Entreprise enregistrée avec succès !');
      onComplete(response.data.user);
    } catch (err) {
      console.error('Error updating company:', err);
      setError(err.response?.data?.message || 'Erreur lors de l\'enregistrement');
      setSubmitting(false);
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={() => {}} // Empêcher la fermeture sans remplir l'entreprise
      backdrop="static" 
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>
          <i className="bi bi-building me-2"></i>
          Informations complémentaires
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Alert variant="info" className="border-0">
            <i className="bi bi-info-circle me-2"></i>
            <strong>Bienvenue sur Assistance Video !</strong>
            <p className="mb-0 mt-2 small">
              Pour finaliser votre profil, veuillez renseigner le nom de votre entreprise.
              Cette information nous permet de mieux vous accompagner.
            </p>
          </Alert>

          <Form.Group className="mt-4">
            <Form.Label className="fw-semibold">
              <i className="bi bi-building me-2"></i>
              Nom de votre entreprise <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              value={company}
              onChange={(e) => {
                setCompany(e.target.value);
                setError(''); // Effacer l'erreur quand l'utilisateur tape
              }}
              placeholder="Ex: Ma Société SARL"
              isInvalid={!!error}
              disabled={submitting || loading}
              autoFocus
            />
            {error && (
              <Form.Control.Feedback type="invalid">
                {error}
              </Form.Control.Feedback>
            )}
            <Form.Text className="text-muted">
              Cette information peut être modifiée ultérieurement dans votre profil.
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            variant="primary" 
            type="submit"
            disabled={!company || company.trim() === '' || submitting || loading}
          >
            {submitting || loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Enregistrement...
              </>
            ) : (
              <>
                <i className="bi bi-check-circle me-2"></i>
                Continuer
              </>
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CompanyModal;
